import React from "react";

const ChatHeader = ({ themes, toggleChatBot, chatType, InforLink }) => {
    return (
        <div
            style={{ backgroundColor: themes.primaryColor }}
            className={`chatbot-header`}
        >
            <a
                href={InforLink}
                target="_blank"
                className="chatbot-header-info"
                title="Hướng dẫn sử dụng chatbot"
                rel="noopener noreferrer"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="20"
                >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                </svg>
            </a>
            <div style={{ color: themes.logoColor }} className="chatbot-header-title">
                <p>
                    {chatType === "spa"
                        ? "Chanh Spa Nail"
                        : chatType === "tantien"
                            ? "Tân Tiến"
                            : chatType === "smtminhha"
                                ? "SMT Minh Hà"
                                : "Sudo Ecommerce"}
                </p>
            </div>
            <a className="chatbot-header-close-button" onClick={toggleChatBot}>
                <svg
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
            </a>
        </div>
    );
};

export default ChatHeader;
